
'use strict';

const config = {
    submitEvent: 'submit',
    triggerTarget: '.js-add-to-list',
    addToListUrlData: 'add-to-list-url',
    itemCountElementTarget: '.js-list-item-count',
    itemCountSpanTarget: '.js-list-item-count-number',
    resultsWrapper: '.js-obsman-results',
    addToListButton: '.c-button',
    loadingModifier: 'c-button--loading'
};

class AddToList {

    constructor() {
        this.setupClickEvents();
    }

    /**
     * Sets up all events for add to list component.
     */
    setupClickEvents() {
        $(config.triggerTarget).on(config.submitEvent, (e) => this.handleAddToListSubmit(e));
    }

    /**
     * Handles trigger for adding to list
     *
     * @param {event} e
     * @return {Promise}
     */
    handleAddToListSubmit(e) {
        e.preventDefault();

        const form = $(e.target);
        const url = form.data(config.addToListUrlData);
        const params = form.serialize();

        form.find(config.addToListButton).addClass(config.loadingModifier);

        return $.post(url, params, function(response, status, requestObject) {
            replaceForm(response);
            updateListCount(requestObject);
        }).fail(function(responseObject) {
            insertError(responseObject);
        }).always(function() {
            form.find(config.addToListButton).removeClass(config.loadingModifier);
        });

        function replaceForm(response) {
            form.replaceWith(response);
        }

        function updateListCount(requestObject) {
            const count = requestObject.getResponseHeader('X-Item-Count');

            // Check count is numeric
            if (!isNaN(parseFloat(count)) && isFinite(count)) {
                $(config.itemCountElementTarget).find(config.itemCountSpanTarget).html(count);
            }
        }

        function insertError(responseObject) {
            $(config.resultsWrapper).before('<br />' + responseObject.responseText);
        }
    }
}

$(window).load(function(){
    new AddToList();
});



// WEBPACK FOOTER //
// ./src/js/components/add-to-list.js